import { useCompanyRedirectValidateQuery } from "api/company";
import { useConfig } from "contexts/ConfigContext";
import { useEffect, useState } from "react";

import useQueryParams from "./useQueryParams";

const useContinueRedirectUrl = (companyId: string) => {
  const [redirectUrl, setRedirectUrl] = useState("");
  const {
    state: { data: config },
  } = useConfig();
  const queryParams = useQueryParams();
  const continueQueryParam = queryParams.get("continue");
  const canContinue = continueQueryParam !== null;
  const [, validateCompanyRedirect] = useCompanyRedirectValidateQuery({
    companyId,
    redirectUrl: continueQueryParam ?? "",
  });

  useEffect(() => {
    async function validateRedirect() {
      try {
        await validateCompanyRedirect();
        setRedirectUrl(continueQueryParam ?? "");
      } catch (e) {
        setRedirectUrl("");
      }
    }

    if (config?.hasCustomRedirect && continueQueryParam) {
      validateRedirect();
    }
  }, [validateCompanyRedirect, continueQueryParam, config]);

  return { redirectUrl, canContinue };
};

export default useContinueRedirectUrl;
